var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C62.092 0 80 17.908 80 40C80 62.092 62.092 80 40 80C17.908 80 0 62.092 0 40C0 17.908 17.908 0 40 0ZM40 5.58C30.8712 5.58 22.1164 9.20638 15.6614 15.6614C9.20638 22.1164 5.58 30.8712 5.58 40C5.58 49.1288 9.20638 57.8836 15.6614 64.3386C22.1164 70.7936 30.8712 74.42 40 74.42C49.1288 74.42 57.8836 70.7936 64.3386 64.3386C70.7936 57.8836 74.42 49.1288 74.42 40C74.42 30.8712 70.7936 22.1164 64.3386 15.6614C57.8836 9.20638 49.1288 5.58 40 5.58ZM39.42 28.84C40.96 28.84 42.208 30.092 42.208 31.632V61.864C42.1807 62.5857 41.8748 63.2687 41.3545 63.7696C40.8343 64.2705 40.1402 64.5503 39.418 64.5503C38.6958 64.5503 38.0017 64.2705 37.4815 63.7696C36.9612 63.2687 36.6553 62.5857 36.628 61.864V31.628C36.628 30.088 37.876 28.836 39.42 28.836V28.84ZM39.532 17.68C40.5186 17.68 41.4648 18.0719 42.1624 18.7696C42.8601 19.4672 43.252 20.4134 43.252 21.4C43.252 22.3866 42.8601 23.3328 42.1624 24.0304C41.4648 24.7281 40.5186 25.12 39.532 25.12C38.5454 25.12 37.5992 24.7281 36.9016 24.0304C36.2039 23.3328 35.812 22.3866 35.812 21.4C35.812 20.4134 36.2039 19.4672 36.9016 18.7696C37.5992 18.0719 38.5454 17.68 39.532 17.68Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.0798eeba.svg";
export { ForwardRef as ReactComponent };